export const GOOGLE_CLIENT_ID = '650017906175-smpl2hqetvs8i35aht5id9mfhchndr1i.apps.googleusercontent.com'
export const DEFAULT_PAGE_SIZE = 20

export const MAP_QUERY_MODE = 'map-query-mode';
export const MAP_EDIT_MODE = 'map-edit-mode';
export const MAP_CREATE_MODE = 'map-create-mode';
